import React from 'react';
import Blog from 'components/views/Blog';
import { Footer, Header } from 'components/views';

export default function BlogWrapper({
  data,
  search,
  categories,
  handleSearch,
  handleCategory,
  handleDetailMove,
  handleLoadMore,
  hasMore,
}) {
  return (
    <>
      <Header />
      <Blog
        data={data}
        search={search}
        categories={categories}
        handleSearch={handleSearch}
        handleCategory={handleCategory}
        handleDetailMove={handleDetailMove}
        handleLoadMore={handleLoadMore}
        hasMore={hasMore}
      />
      <Footer />
    </>
  );
}
